import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Mainpage from "./Homepage";
import AboutKtig from "./About_KTIG";

import Blog from "./Blog";
import ContactUs from "./ContactUs";

import Corporateoffice from "./Corporateoffice";
import Adminpage from "./Adminpage";
import InvoiceForm from "./Bankinvoice";
import Privacy from "./Privacy";
import Businesshours from "./Businesshours";
import CVUploadForm from "./Uploadcvdesign";
import Noopenings from "./Noopeningspage";
import BlogDetailPage from "./Detailedview";
import Termsandconditions from "./Termsandconditions";
import VisionandMission from "./VisionandMission";
import BoardofDirectors from "./BoardofDirectors";
import KTNL_LP from "./KTNL_LP";
import BrAcademyLp from "./BR_Academy_LP";
import Events from "./Events";
import FinancePartner from "./Finance_Partner";
import JointVenturePartner from "./Joint_Venture_Partner";
import ConsultingPartner from "./Consulting_Partner";
import SponsorshipPartner from "./Sponsorship_Partner";
import KtmcPage from "./Ktmcpage";
import ScrollToTop from "./ScrollToTop";
import Dashboard from "./Login";
import ConatctDataTable from "./Contacdatatable";
import KtnlEnquiryforms from "./KtnlEnquiryform";
import Ktnlcustomersupport from "./Ktnlcustomersupportcontent";
import DataTable from "./Datatable";
import DataTable2 from "./Datatable2";

import ContactDataTable from "./Contacdatatable";
import AddBlogForm from "./AddbBlogform";
import AddEventForm from "./AddEventForm";
import NotFound from "./NotFound";

import AdminDashboard from "./Admin_Dashboard";
import CommonContactForm from "./common_contact_form";
import BnrCogniitecLp from "./BNR_Cogniitec_LP";
import BoardofdirectDetails from "./BoardofdirectDetails";
import CreateCareerDetails from "./CreateCareerDetails";
import UpdateCareerDetails from "./UpdateCareerDetails";
import ViewCareerDetails from "./viewCareerDetails";
import CreateCareer from "./CreateCareers";
import ViewBlogDetails from "./viewBlogDetails";
import ViewEventDetails from "./viewEventDetails";

import BioDataTable from "./BioDataTable";
import CreateBioData from "./CreateBioData";
import UpdateBioData from "./UpdateBioData";
import ViewBioData from "./viewBioData";
import AdminUserprofile from "./AdminUserprofile";
import ViewContactDetails from "./viewContactDetails";
import JobApplicationTable from "./jobApplicationTable";
import ViewJobApplicationDetails from "./viewJobApplicationDetails";
import ProtectedRoute from "./ProtectedRoute";
import PageUnderConstruction from "./PageUnderConstruction";
import UserDeleteReqeust from "./UserDeleteRequest";
import AccountDelRequestTable from "./AccountDelRequestTable";
import SkillOrea_LP from "./SkillOrea_LP";
import Pavalsoft_lp from "./Pavalsoft_Lp";
function App() {
  return (
    <Router>
      <ScrollToTop />
      <div>
        <Routes>
          <Route exact path="/" element={<Mainpage />} />

          <Route path="/about-ktig" element={<AboutKtig />} />
          <Route path="/vision-mission" element={<VisionandMission />} />
          <Route path="/board-of-directories" element={<BoardofDirectors />} />
          <Route
            path="/board-of-directories-details"
            element={<BoardofdirectDetails />}
          />
          <Route path="/kovai-tech-nidhi-limited" element={<KTNL_LP />} />
          <Route path="/bnr-cogniitec" element={<BnrCogniitecLp />} />
          <Route path="/br-academy" element={<BrAcademyLp />} />
          <Route path="/kovai-tech-member-chamber" element={<KtmcPage />} />
          <Route path="/events" element={<Events />} />
          <Route path="/finance-partner" element={<FinancePartner />} />
          <Route
            path="/joint-venture-partner"
            element={<JointVenturePartner />}
          />
          <Route path="/consulting-partner" element={<ConsultingPartner />} />
          <Route path="/sponsorship-partner" element={<SponsorshipPartner />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact-us" element={<ContactUs />} />

          <Route path="/corporate-office" element={<Corporateoffice />} />
          <Route path="/business-hours" element={<Businesshours />} />
          <Route path="/privacy-policies" element={<Privacy />} />
          <Route path="/invoice-form" element={<InvoiceForm />} />
          <Route path="/upload-cv" element={<CVUploadForm />} />
          <Route path="/current-openings" element={<Noopenings />} />
          <Route path="/detailed-view" element={<BlogDetailPage />} />
          <Route path="/terms-conditions" element={<Termsandconditions />} />

          <Route path="/user-delete-request" element={<UserDeleteReqeust />} />
          <Route path="/admin-Login" element={<Adminpage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          >
            <Route path="blogs" element={<ConatctDataTable />} />
            <Route path="enquiry-form" element={<KtnlEnquiryforms />} />
            <Route
              path="ktnl-customer-support"
              element={<Ktnlcustomersupport />}
            />
            <Route
              path="blog-news"
              element={
                <ProtectedRoute>
                  <DataTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="event"
              element={
                <ProtectedRoute>
                  <DataTable2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin-dashboard"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="contact"
              element={
                <ProtectedRoute>
                  <ContactDataTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-blog"
              element={
                <ProtectedRoute>
                  <AddBlogForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-event"
              element={
                <ProtectedRoute>
                  <AddEventForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-blog-details"
              element={
                <ProtectedRoute>
                  <ViewBlogDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-event-details"
              element={
                <ProtectedRoute>
                  <ViewEventDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/create-careers"
              element={
                <ProtectedRoute>
                  <CreateCareer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-careers-details"
              element={
                <ProtectedRoute>
                  <ViewCareerDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/update-careers-details"
              element={
                <ProtectedRoute>
                  <UpdateCareerDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/create-careers-details"
              element={
                <ProtectedRoute>
                  <CreateCareerDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bio-data-table"
              element={
                <ProtectedRoute>
                  <BioDataTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/create-bio-data"
              element={
                <ProtectedRoute>
                  <CreateBioData />
                </ProtectedRoute>
              }
            />
            <Route
              path="/update-bio-data"
              element={
                <ProtectedRoute>
                  <UpdateBioData />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-bio-data"
              element={
                <ProtectedRoute>
                  <ViewBioData />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin-profile"
              element={
                <ProtectedRoute>
                  <AdminUserprofile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-contact-details"
              element={
                <ProtectedRoute>
                  <ViewContactDetails />
                </ProtectedRoute>
              }
            />

            <Route
              path="/job-application-table"
              element={
                <ProtectedRoute>
                  <JobApplicationTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-job-application"
              element={<ViewJobApplicationDetails />}
            />
            <Route
              path="/account-deletion"
              element={<AccountDelRequestTable />}
            />

            <Route
              path="/common-contact-form"
              element={<CommonContactForm />}
            />
          </Route>

          <Route path="/paval-soft" element={<Pavalsoft_lp />} />
          <Route path="/skillorea" element={<SkillOrea_LP />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
